import { alert, Stack } from '@pnotify/core'
import '@pnotify/core/dist/PNotify.css'
import '@pnotify/core/dist/BrightTheme.css'

globalThis.PNotify = { alert, Stack }
